module.exports = __webpack_public_path__ + "img/urgent-bell.0c9cbe54.png";